import React, { Component } from 'react';
import {connect} from 'react-redux';
import { itemsFetchData} from './actions/actions';
import {bindActionCreators} from 'redux';
import './App.css';
import Header from './components/Header.js';
import Slider from './components/Slider.js';
import PicadaRow from './containers/PicadaRow.js';
import Modal from './containers/modal';
import Footer from './containers/footer';

class App extends Component {

  componentDidMount() {
    const apiUrl = 'https://picadaclub.com.ar/admin/dbData.php';
    // const apiUrl = 'https://localhost/admin/dbData.php';
    this.props.itemsFetchData(apiUrl);
  }
  render () {
    return (
      <div className='App'>
        <Header />
        <div className='main-container' id="main">
          <div className="slider">
            <Slider />
          </div>
          <PicadaRow items={this.props.items.picadas}/>
          <Footer  delivery={this.props.items.delivery}/>
          <Modal />
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    items: state.items,
    hasErrored: state.itemsHasErrored,
    isLoading: state.itemsIsLoading
  };
}
const mapDispatchToProps= (dispatch) => {
  return bindActionCreators({ itemsFetchData}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/


/** WEBPACK FOOTER **
 ** ./src/App.js
 **/